import { render, staticRenderFns } from "./error-no-employee-endpoints.vue?vue&type=template&id=41d0a79a&scoped=true&"
import script from "./error-no-employee-endpoints.vue?vue&type=script&lang=js&"
export * from "./error-no-employee-endpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d0a79a",
  null
  
)

export default component.exports